module.exports = __webpack_public_path__ + "img/setor_financeiro.c5684437.png";